import { render, staticRenderFns } from "./Wap_ZRD004_Step2.vue?vue&type=template&id=acf3f1a6&scoped=true&"
import script from "./Wap_ZRD004_Step2.vue?vue&type=script&lang=js&"
export * from "./Wap_ZRD004_Step2.vue?vue&type=script&lang=js&"
import style0 from "./Wap_ZRD004_Step2.vue?vue&type=style&index=0&id=acf3f1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf3f1a6",
  null
  
)

export default component.exports